import { css } from 'styled-components';
import token from 'styled-token';
import { hexToAlpha } from '../../util/hexToAlpha';
import { spaceMixin } from '../spaceMixin';

/** @class TabMixin */
/** @method */
export var TabMixin = function TabMixin(props) {
  return token({
    backgroundColor: 'Tabs.backgroundColor',
    fontWeight: 'Tabs.Tab.fontWeight',
    borderWidth: 'Button.borderWidth'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      fontWeight = _ref.fontWeight,
      borderWidth = _ref.borderWidth;
    return css(["background-color:", ";border-radius:0;font-weight:", ";justify-content:flex-start;overflow:hidden;white-space:nowrap;&:hover:not(:disabled){cursor:pointer;}&[aria-selected='false']:before{background:linear-gradient( 90deg,", " 0%,", " 75%,", " );content:'';display:block;height:calc( 100% - ", "px - 5px );position:absolute;right:0;top:", "px;width:", ";}&[aria-selected='true']{flex-shrink:0;}&[aria-selected='true']:before{display:none;}"], backgroundColor, fontWeight, hexToAlpha(backgroundColor, 0), hexToAlpha(backgroundColor, 1), hexToAlpha(backgroundColor, 1), borderWidth * 2, borderWidth, spaceMixin('sm')(props));
  })(props);
};